"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _documentPane = _interopRequireDefault(require("./document-pane"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledTitle = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "document-listing__StyledTitle",
  componentId: "sc-14nu0oj-0"
})(["line-height:45px;"]);
var propTypes = {
  /** Array of results to display */
  documentsList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,

  /** Default handler for download item onClick */
  downloadAction: _propTypes.func,

  /** heading tag */
  headingTag: _propTypes.string,

  /** Number of maximum items to show */
  maxItemsToShow: _propTypes.number,

  /** Handler to be called when the show more button is clicked */
  moreButtonOnClick: _propTypes.func,

  /** Title of type string */
  title: _propTypes.string
};

var DocumentListing = function DocumentListing(_ref) {
  var documentsList = _ref.documentsList,
      downloadAction = _ref.downloadAction,
      headingTag = _ref.headingTag,
      maxItemsToShow = _ref.maxItemsToShow,
      moreButtonOnClick = _ref.moreButtonOnClick,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    flexDirection: ["column", "row"]
  }, title && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: [6, 3],
    pr: [0, 4]
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    fontSize: [6, 9],
    fontWeight: [1, 2],
    px: [2, 0],
    py: [2, 0],
    tag: headingTag
  }, title)), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: title ? [6, 5, 9] : [6, 8, 12]
  }, /*#__PURE__*/_react["default"].createElement(_documentPane["default"], {
    documentsList: documentsList,
    downloadAction: downloadAction,
    maxItemsToShow: maxItemsToShow,
    moreButtonOnClick: moreButtonOnClick
  })));
};

DocumentListing.propTypes = propTypes;
DocumentListing.displayName = "Modules.DocumentListing";
var _default = DocumentListing;
exports["default"] = _default;